module.exports = __webpack_public_path__ + "static/ewa-c230444cd7573761067d788ecab524a9.png";